import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const MicrowaveIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"microwave"} ref={ref}/>
});

MicrowaveIcon.displayName = "MicrowaveIcon";
